module.exports = __webpack_public_path__ + "img/p2-33.fe9b5826.png";